
import { defineComponent, PropType, reactive } from 'vue'
import { copyToClipboard } from '@/api/tools'
import { getDriverLink } from '@/api/tripply/live'
import { Route } from '@/api/tripply/models/Route'
import { store } from '@/store'

export default defineComponent({
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    }
  },
  components: { },
  name: 'AssignDriver',
  setup(props) {

    
    
    const state = reactive({
      driverLink: getDriverLink(props.route.id),
      isPrivate: props.route.settings.private,
      loading: false
    })
        
    function copy() {
      state.driverLink && copyToClipboard(state.driverLink)
    }

    async function makePublic() {
      state.loading = true
      await store.route.updateSettings(props.route.id, { private: false })
      state.isPrivate = false
      state.loading = false
    }
    
    return { state, copy, makePublic }
  }
})
